// config.js
const viteEnv = import.meta.env || {};

export const WS_BASE_URL = (() => {
  const rawEnvWs =
    (viteEnv.VITE_EXTERNAL_WSS_URL ||
      viteEnv.VITE_EXTERNAL_WSS_ADDRESS ||
      '').trim();
  const envWs = rawEnvWs === 'wss://chat.bluezap.com.br/' ? '' : rawEnvWs;
  const normalizeDoubleScheme = (value) => {
    if (!value) return value;
    return value.replace(/^(wss?:\/\/)(https?:\/\/)/i, (_match, wsPart) => wsPart);
  };
  const normalizeWsBase = (input) => {
    if (!input) return '';
    let normalized = normalizeDoubleScheme(input)
      .replace(/^https?:\/\//, (m) => (m === 'https://' ? 'wss://' : 'ws://'))
      .replace(/\/+$/, '');

    const hasPath = /^wss?:\/\/[^/]+\/.+/.test(normalized);
    if (!hasPath) {
      normalized = `${normalized}/api`;
    }

    if (
      typeof window !== 'undefined' &&
      window.location?.protocol === 'https:' &&
      normalized.startsWith('ws://')
    ) {
      normalized = normalized.replace(/^ws:\/\//, 'wss://');
    }

    return normalized;
  };

  const buildPageBase = () => {
    if (typeof window === 'undefined') return '';
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    return `${proto}://${window.location.host}/api`;
  };

  const normalizedEnv = normalizeWsBase(envWs);
  const pageBase = buildPageBase();

  if (typeof window !== 'undefined') {
    const pageHost = window.location.host;
    const pageHostname = window.location.hostname;
    const isLocalhost = pageHostname === 'localhost' || pageHostname === '127.0.0.1';

    if (!normalizedEnv || isLocalhost) {
      return pageBase;
    }

    let envHost = null;
    try {
      envHost = new URL(normalizedEnv).host;
    } catch {
      envHost = null;
    }

    if (envHost && envHost !== pageHost && pageBase) {
      // Prioriza o mesmo host da página para garantir envio de cookies (evita 401 nos WS)
      return pageBase;
    }

    if (envHost && envHost === pageHost) {
      return normalizedEnv;
    }
  }

  if (normalizedEnv) {
    return normalizedEnv;
  }

  return pageBase || 'ws://localhost/api';
})();

export const APP_VERSION = viteEnv.VITE_APP_VERSION || 'v3.1.9';

export const APP_TIME_ZONE = (() => {
  const raw = (viteEnv.VITE_APP_TIME_ZONE || '').trim();
  const configured = raw === 'America/Sao_Paulo' ? '' : raw;
  if (typeof Intl === 'undefined') {
    return configured || 'UTC';
  }
  const browserTimeZone =
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  const candidates = [configured, browserTimeZone, 'UTC'].filter(Boolean);
  for (const candidate of candidates) {
    try {
      new Intl.DateTimeFormat('pt-BR', { timeZone: candidate }).format(new Date());
      return candidate;
    } catch {
      // Ignore invalid timezone values and try the next fallback.
    }
  }

  return 'UTC';
})();

export const WHATSAPP_SESSION_ID = (() => {
  const raw =
    (viteEnv.VITE_WHATSAPP_SESSION_ID ||
      viteEnv.VITE_WA_SESSION_ID ||
      '').trim();
  const normalized = raw === '01' ? '' : raw;
  return normalized || '';
})();
